// @ts-nocheck

import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { changeCampaign } from 'Redux/actions/scheduleActions'
import {
  getCampaignToSchedule,
  getAmountOfCampaigns,
} from 'Redux/selectors/campaigns'
import { getBudgetRange } from 'Redux/selectors/scheduledCampaign'
import { getCurrency, getUserSelector } from 'Redux/selectors/auth'
import { currencySymbolConverter } from 'Constants/functions'
import { Currency, BudgetRange, CampaignPlatformTypeEnum } from 'Types/index'
import { campaignBudgetUpdateEvent } from 'Helpers/tagManager'

interface useBudgetProps {
  budget?: number
}

export const useBudget = ({ budget = 0 }: useBudgetProps) => {
  const dispatch = useDispatch()

  const [componentDidMount, setComponentDidMount] = useState(false)

  const campaignDetails = useSelector(getCampaignToSchedule)
  const currency: Currency = useSelector(getCurrency)
  const burgetRange: BudgetRange = useSelector(getBudgetRange)
  const user = useSelector(getUserSelector)
  const amountOfCampaigns = useSelector(getAmountOfCampaigns)

  const convertFromUsd = (value: number) => value * currency.rate

  const convertToUsd = (value: number) => value / currency.rate

  useEffect(() => {
    if (budget) {
      dispatch(
        changeCampaign(
          {
            campaign_id: campaignDetails.id,
            genres_ids: campaignDetails?.genres.map(el => el.id),
            languages_ids: campaignDetails?.languages.map(el => el.id),
            moods_ids: null,
            max_price: convertToUsd(budget),
          },
          (error, payload) => {
            componentDidMount &&
              campaignBudgetUpdateEvent(
                campaignDetails.type,
                CampaignPlatformTypeEnum.SPOTIFY,
                amountOfCampaigns,
                campaignDetails.id,
                user.id,
                payload.price,
                campaignDetails?.genres.map(genre => genre.name).join(),
                campaignDetails?.languages
                  .map(language => language.name)
                  .join(),
                campaignDetails.is_feed || false
              )
            setComponentDidMount(true)
          }
        )
      )
    }
  }, [budget])

  const currencyName = currency.name

  const currencyRate = currency.rate

  const currencySymbol = currencySymbolConverter(currency.name)

  const step = Math.ceil(currency.rate * 10)

  const sliderParameters = {
    step,
    max: Math.ceil(convertFromUsd(burgetRange?.max) / step) * step,
    min: Math.ceil(convertFromUsd(burgetRange?.min) / step) * step,
  }

  return {
    convertFromUsd,
    convertToUsd,
    currencyName,
    currencyRate,
    currencySymbol,
    sliderParameters,
  }
}
